import React from 'react';
import PropTypes from 'prop-types';
import Utils from '../../Utils';

const Project = ({ children, data = {}, onMouseOver, onMouseOut, onMouseClick, ...props }) => {
  const handleMouseOver = () => {
    onMouseOver(data.keywords);
  };

  const handleMouseOut = () => {
    onMouseOut();
  };

  const handleMouseClick = () => {
    onMouseClick({ 
      "uuid": Utils.uuid(),
      "projects": data.detail
    });
  }

  return (
    <div className="project" onMouseOver={handleMouseOver} onMouseOut={handleMouseOut} onClick={handleMouseClick}>
      <div className="tile-container">
        <div className="thumb" style={{backgroundImage: `url(./images/resume/${data.thumbnail})`}} />
        <div className="thumb-blur" style={{backgroundImage: `url(./images/resume/${data.thumbnail})`}} />
        <div className="blurb-container">
          <span className="blurb">{data.blurb}</span>
        </div>
      </div>
      <span className="title">{data.title}</span>
    </div>
  );
};

Project.propTypes = {
  data: PropTypes.object.isRequired,
  onMouseOver: PropTypes.func.isRequired,
  onMouseOut: PropTypes.func.isRequired,
};

export default Project;



// WEBPACK FOOTER //
// ./src/components/resume/Project.js